module.exports = __webpack_public_path__ + "img/qian-one.c835ae38.png";